<ng-container *ngIf="!showNoActiveCertificatesFoundView; else noActiveCertificatesFoundBlock">
<div class="align-top" *ngIf="!submit; else secretKeyBlock">
  <span class="show-err">{{responseResult}}</span>
  <span class="em-text">{{'auth.emergencyLogin.textExplain' | translate}}</span>
  <div class="label">{{'settingsList.phoneFormat' | translate}}</div>
  <div class="label">{{'settingsList.foreignPhone' | translate}}</div>
  <form [formGroup]="emergencyForm" (ngSubmit)="onSubmit(emergencyRequestId.value)">

    <div class="form-group full-width divider">
      <mat-form-field class="emergency-first-input" appearance="fill">
        <input matInput placeholder="{{'auth.emergency.userInput' | translate}}" class="tal emerg-input"
          formControlName="emergencyRequestId" #emergencyRequestId minlength="5" required autocomplete="off" />
        <mat-error *ngIf="emergencyForm.controls.emergencyRequestId.errors">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>

    <div>
      <div class="captcha">
        <ngx-recaptcha2 *ngIf="captchaEnabled" [siteKey]="reCaptcha2SiteKey" [size]="size" [hl]="usingLang" [theme]="theme" [type]="type"
          (expire)="handleRecaptchaExpire()" (load)="handleRecaptchaLoad()" (success)="handleRecaptchaSuccess($event)"
          formControlName="recaptcha">
        </ngx-recaptcha2>
      </div>

      <div class="container-emerg-btn">
        <button type="button" mat-stroked-button (click)="goBack()">
          {{'auth.cancel' | translate}}
        </button>
        <button type="submit" mat-raised-button color="primary" [disabled]="!emergencyForm.valid"
          (click)="info.dismissAll()" (keypress)="info.dismissAll()" id="btn-1">
          {{'auth.emergency.continued'| translate}}
        </button>
      </div>
    </div>
  </form>
</div>
</ng-container>

<ng-template #noActiveCertificatesFoundBlock>
  <no-active-certificates-found (goBackEmit)="goBack()"></no-active-certificates-found>
</ng-template>

<ng-template #secretKeyBlock class="emergency-last-section">

  <div class="text-container">
    <p class="show-err">{{secretKeyRes}}</p>
    <span>{{'auth.emergency.on' | translate }}</span>
    <span class="user-input">'{{ personalId }}'</span> <br>
    <span>{{'auth.emergency.codeExplain' | translate}}<strong>{{'auth.emergency.codeValid' | translate}}</strong></span>
  </div>

  <form (ngSubmit)="sendSecretCode(code.value)" #sKeyForm="ngForm">

    <div class="form-group full-width divider">
      <mat-form-field appearance="fill">
        <input matInput [placeholder]="'auth.emergency.secretCodePlaceholder' | translate" class="tal" ngModel #code
          name="secretKey" required minlength="6" autocomplete="off" />
      </mat-form-field>
    </div>

    <div class="login-btn">
      <button type="submit" mat-raised-button color="primary" (click)="info.dismissAll()" (keypress)="info.dismissAll()"
        [disabled]="!sKeyForm.form.valid">{{'auth.login' | translate}}</button>
    </div>

  </form>
</ng-template>